export default "__VITE_ASSET__DfMNDkpM__"